import { render, staticRenderFns } from "./client_testimonials.vue?vue&type=template&id=11094026&scoped=true&"
import script from "./client_testimonials.vue?vue&type=script&lang=js&"
export * from "./client_testimonials.vue?vue&type=script&lang=js&"
import style0 from "./client_testimonials.vue?vue&type=style&index=0&id=11094026&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11094026",
  null
  
)

export default component.exports